(function () {
  'use strict';

  /**
   * Usage:
   * <input type="text" autofocus>
   */
  angular.module('wsLrs.directives').directive('ngAutofocus', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      link: function link($scope, $element) {
        $timeout(function () {
          $element[0].focus();
        }, 100);
      }
    };
  }]).directive('clickToCopy', ['Alerts', function (Alerts) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        elem.click(function (clickElement) {
          // Let's ignore listening here if the target is an anchor since more than likely
          // we actually want to execute the click function of the anchor, not this one.
          var ignoreTargetClick = clickElement.target.nodeName === 'A';
          if (ignoreTargetClick) {
            return;
          }
          if (attrs.clickToCopy) {
            var $temp_input = $("<input>");
            $("body").append($temp_input);
            $temp_input.val(attrs.clickToCopy).select();
            document.execCommand("copy");
            $temp_input.remove();
            Alerts.raiseAlert({
              "type": "info",
              "text": "Copied \"" + attrs.clickToCopy + "\" to clipboard",
              "autoDismiss": true,
              "autoDismissTimeout": 2500
            });
            scope.$apply();
          }
        });
      }
    };
  }]);
})();
